import React, { useContext } from "react";

import { ContextoListaApartamentos } from "../../ApartamentList/contextoImoveis";

import { ItemCabecalho } from "./styles";
const ItemCabecalhoComponent = ({
  title,
  info,
  icon,
  confirmarSolicitacao,
  id,
}) => {
  const { tema } = useContext(ContextoListaApartamentos);

  let estiloConfirmarSolicitacaoItem = {};
  let estiloConfirmarSolicitacaoContainer = {};

  if (confirmarSolicitacao) {
    estiloConfirmarSolicitacaoItem = { width: "100%" };
    estiloConfirmarSolicitacaoContainer = { width: "95%" };
  }

  return (
    <ItemCabecalho tema={tema} style={estiloConfirmarSolicitacaoItem}>
      <div
        className="container centralized-column"
        style={estiloConfirmarSolicitacaoContainer}
      >
        <span>{title}</span>
        <span id={id}>{info}</span>
      </div>
      <span className="cabecalhoIcon">{icon}</span>
    </ItemCabecalho>
  );
};

export default ItemCabecalhoComponent;
